import React, { useEffect, useState } from "react";
import Input from "../../../components/Commons/Input";
import { Select } from "../../../components/Commons/Select";
import { useTranslation } from "react-i18next";
import { workAddressSelect } from "../../../utils/constants/constant";
import { Regex } from "../../../utils/constants";
import { stringHelper } from "../../../utils/helpers";
import { fetchGetAddressData } from "../../../utils/helpers/api";
import { useGlobalState } from "../../../contexts/GlobalContext";
import Minus from "../../../components/svg/Minus";
import Plus from "../../../components/svg/Plus";
import ErrorMsg from "../../../components/Commons/ErrorMsg";

const HomePlace: React.FC<IContactFormProps> = (props) => {
  const { t } = useTranslation();
  const {
    isEdit = true,
    onChangeData,
    onChangeValidate,
    onChangeSubData,
    onGetErr,
    formData,
    errorMess,
    id,
    forceWorkPlaceValidate,
  } = props;
  const [state, setState] = useState<IHomeFormState>({
    userMetaData: {},
  });
  const { userMetaData } = state;
  const [visibleForms, setVisibleForms] = useState<boolean>(true);
  const [subValue, setSubValue] = useState({
    homeZip01: "",
    homeZip02: "",
    prefectureCode: 0,
    homePhone01: "",
    homePhone03: "",
    homePhone02: "",
    homeMobile01: "",
    homeMobile02: "",
    homeMobile03: "",
  });

  const [errors, setErrors] = useState({
    prefectureCode: "",
    work_phone: "",
    homeZip01: "",
    homeZip02: "",
    homePhone01: "",
    homePhone03: "",
    homePhone02: "",
    homeMobile01: "",
    homeMobile02: "",
    homeMobile03: "",
    city: "",
    line: "",
  });

  useEffect(() => {
    if (forceWorkPlaceValidate) return;
    // handle error when change status 連絡先種別
    if(userMetaData?.profile?.contactType != undefined)
      if(userMetaData?.profile?.contactType != formData?.profile?.contactType) {
        const nameFields = ['homeZip01', 'homeZip02', 'prefectureCode', 'homePhone01', 'homePhone02', 'homePhone03'] as const;
        if(formData?.profile?.contactType !== 1) {
          nameFields.forEach(field => {
            if(errors[field] === t("common.required")) {
              setErrors(prevErrors => ({
                ...prevErrors,
                [field]: "",
              }));
            }
          });
        } else {
          nameFields.forEach(field => {
            if(subValue[field] == '') {
              setErrors(prevErrors => ({
                ...prevErrors,
                [field]: t("common.required"),
              }));
            }
          });
        }
      }
  }, [formData?.profile?.contactType]);

  useEffect(() => {
    if (onChangeData) {
      onChangeData(userMetaData ?? {});
    }
    if (onChangeValidate) {
      onChangeValidate(handleCountCurrentValid());
    }
    if (onGetErr) {
      onGetErr(Object.values(errors).some(Boolean));
    }
  }, [state, errors, subValue]);

  useEffect(() => {
    if (onChangeSubData) {
      onChangeSubData(subValue);
    }
  }, [subValue]);

  useEffect(() => {
    if (errorMess && errorMess.length > 0) {
      errorMess.forEach((error) => {
        setErrors((prevErrors) => {
          if (error.field && Object.keys(prevErrors).includes(error.field)) {
            return {
              ...prevErrors,
              [error.field]: error.mess,
            };
          }
          return prevErrors;
        });
      });
    }
  }, [errorMess]);  

  useEffect(() => {
    if (formData) {
      setState((prevState) => {
        if (JSON.stringify(prevState.userMetaData) !== JSON.stringify(formData)) {
          return {
            ...prevState,
            userMetaData: {
              ...formData,
            },
          };
        }
        return prevState; 
      });
    }

    if (formData?.profile?.address?.prefectureCode) {
      setSubValue((prevState) => {
        return {
          ...prevState,
          prefectureCode: formData?.profile?.address?.prefectureCode ?? 0
        };
      });
    }
  
    if (formData?.profile?.mobilePhoneNumber) {
      const parts = formData?.profile?.mobilePhoneNumber.split("-");
      setSubValue((prevState) => {
        if (
          parts[0] !== prevState.homeMobile01 ||
          parts[1] !== prevState.homeMobile02 ||
          parts[2] !== prevState.homeMobile03
        ) {
          return {
            ...prevState,
            homeMobile01: parts[0] ?? "",
            homeMobile02: parts[1] ?? "",
            homeMobile03: parts[2] ?? "",
          };
        }
        return prevState;
      });
    }
  
    if (formData?.profile?.phoneNumber) {
      const parts = formData?.profile?.phoneNumber.split("-");
      setSubValue((prevState) => {
        if (
          parts[0] !== prevState.homePhone01 ||
          parts[1] !== prevState.homePhone02 ||
          parts[2] !== prevState.homePhone03
        ) {
          return {
            ...prevState,
            homePhone01: parts[0] ?? "",
            homePhone02: parts[1] ?? "",
            homePhone03: parts[2] ?? "",
          };
        }
        return prevState;
      });
    }
  
    if (formData?.profile?.address?.postalCode) {
      const parts = formData?.profile?.address?.postalCode.split("-");
      setSubValue((prevState) => {
        if (
          parts[0] !== prevState.homeZip01 ||
          parts[1] !== prevState.homeZip02
        ) {
          return {
            ...prevState,
            homeZip01: parts[0] ?? "",
            homeZip02: parts[1] ?? "",
          };
        }
        return prevState;
      });
    }
  
  }, [formData]);
  

  useEffect(() => {
    const formatPhoneNumber = (part1:string, part2:string, part3:string) =>
      part1 && part2 && part3
        ? stringHelper.formatHalfWidthText(`${part1}-${part2}-${part3}`)
        : "";
  
    setState((prevState) => {
      const updatedUserMetaData = { ...prevState.userMetaData };
      const updatedProfile = { ...updatedUserMetaData.profile };
  
      updatedProfile.address = {
        ...updatedProfile.address,
        postalCode: subValue.homeZip01 && subValue.homeZip02
          ? stringHelper.formatHalfWidthText(`${subValue.homeZip01}-${subValue.homeZip02}`)
          : "",
      };
  
      updatedProfile.phoneNumber = formatPhoneNumber(
        subValue.homePhone01,
        subValue.homePhone02,
        subValue.homePhone03
      );
  
      updatedProfile.mobilePhoneNumber = formatPhoneNumber(
        subValue.homeMobile01,
        subValue.homeMobile02,
        subValue.homeMobile03
      );
  
      return {
        ...prevState,
        userMetaData: {
          ...updatedUserMetaData,
          profile: updatedProfile,
        },
      };
    });
  }, [subValue]);
  

  useEffect(() => {
    if (
      subValue.homeZip01.length + subValue.homeZip02.length == 7 &&
      !errors.homeZip01 &&
      !errors.homeZip02
    ) {
      handleGetAddress(subValue.homeZip01 + subValue.homeZip02);
    }
  }, [subValue.homeZip01, subValue.homeZip02]);

  useEffect(() => {
    if (onChangeValidate) {
      onChangeValidate(handleCountCurrentValid());
    }
  }, [userMetaData?.profile?.contactType]);

  const handleGetAddress = async (zipCode: string) => {
    try {
      const result = await fetchGetAddressData(zipCode);
      if (result.code == 200) {
        setState((prevState) => ({
          ...prevState,
          userMetaData: {
            ...prevState.userMetaData,
            profile: {
              ...prevState.userMetaData?.profile,
              address: {
                ...prevState.userMetaData?.profile?.address,
                prefectureCode: parseInt(
                  workAddressSelect.find(
                    (address) => address.label == result.data.pref
                  )?.value ?? "0"
                ),
                city: result.data.address,
              },
            },
          },
        }));

        setErrors((prevErrors) => ({
          ...prevErrors,
          city: "",
          prefectureCode: "",
        }));
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleCountCurrentValid = () => {
    if (forceWorkPlaceValidate) return 0;
    const isContactType1 = userMetaData?.profile?.contactType === 1;
    const fields = isContactType1
      ? [
          {
            field:
              userMetaData?.profile?.address?.postalCode &&
              !errors.homeZip01 &&
              !errors.homeZip02,
          },
          {
            field:
              userMetaData?.profile?.phoneNumber &&
              !errors.homePhone01 &&
              !errors.homePhone02 &&
              !errors.homePhone03,
          },
          { field: userMetaData?.profile?.address?.city && !errors.city },
          { field: userMetaData?.profile?.address?.line && !errors.line },
          {
            field:
              userMetaData?.profile?.address?.prefectureCode &&
              !errors.prefectureCode,
          },
        ]
      : [];
    const validFields = fields.filter(Boolean);
    return validFields.reduce((currentValid, item) => {
      return item?.field ? currentValid + 1 : currentValid;
    }, 0);
  };

  const validateField = (field: string, value?: string) => {
    if (forceWorkPlaceValidate) return ""; // Không validate gì cả khi forceWorkPlaceValidate
    switch (field) {
      case "homeZip01":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.postalCodeOnlyNumbers");
        if (value && value?.length < 3)
          return t("validation.postalCodeThreeDigits");
        break;
      case "homeZip02":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.postalCodeOnlyNumbers");
        if (value && value?.length < 4)
          return t("validation.postalCodeFourDigits");
        break;
      case "homePhone01":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.landlineNumberOnlyDigits");
        if (value && value?.length < 2)
          return t("validation.twoDigitsOrMoreRequired");
        if (value && value?.length > 5)
          return t("validation.postalCodeFiveDigits");
        break;
      case "homePhone02":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.landlineNumberOnlyDigits");
        if (value && value?.length > 4)
          return t("validation.postalCodeFourDigits");
        break;
      case "homePhone03":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.landlineNumberOnlyDigits");
        if (userMetaData?.profile?.contactType === 1 && value?.length !== 4) return t("validation.postalCodeFourDigits");
        break;
      case "prefectureCode":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (userMetaData?.profile?.contactType === 1 && value === "0") return t("validation.selectRequired");
        break;
      case "line":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (value && value?.length > 200) return t("validation.max200chars");
        break;
      case "city":
        if (userMetaData?.profile?.contactType === 1 && value?.trim() === "") return t("common.required");
        if (value && value?.length > 80) return t("validation.max80chars");
        break;
      case "homeMobile01":
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.mobileNumberOnlyNumbers");
        if (value && value?.length !== 3)
          return t("validation.postalCodeThreeDigits");
        break;
      case "homeMobile02":
      case "homeMobile03":
        if (!Regex.RULE.NUMBER.test(value ?? ""))
          return t("validation.mobileNumberOnlyNumbers");
        if (value && value?.length !== 4)
          return t("validation.postalCodeFourDigits");
        break;
    }

    return "";
  };
  
  const handleChangeSubValue = (field: string, value?: string) => {
    setSubValue((prev) => ({ ...prev, [field]: value }));
    const error = validateField(field, value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: error,
    }));
  };

  return (
    <div id={id} className="component__workPlace-info">
      <h3
        className="contact-info_title"
        onClick={() => isEdit && setVisibleForms(!visibleForms)}
        style={{ cursor: isEdit ? "pointer" : "default" }}
      >
        <img className="-icon" src="/images/ico_address.svg" />
        {t("features.userSetting.contact.contactTitleHome")}
        {isEdit && (visibleForms ? <Minus /> : <Plus />)}
      </h3>
      {visibleForms ? (
        <>
          <dl className="contact-body">
            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt>
                <label>
                  <span>
                    {t("features.userSetting.contact.homePostalCode")}
                  </span>
                  {userMetaData?.profile?.contactType === 1 && !forceWorkPlaceValidate && isEdit && (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <div className="form-col -col2 ">
                    <div className="form-col_item w-100">
                      <div className="form-input d-flex align-items-center form-zip">
                        <Input
                          name="homeZip01"
                          maxLength={3}
                          width={82}
                          id="homeZip01"
                          value={subValue.homeZip01}
                          validateMess=""
                          placeholder="100"
                          onChange={(value) =>
                            handleChangeSubValue("homeZip01", value)
                          }
                          onBlur={(value) => {
                            if (value && value.length < 3) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                homeZip01: t(
                                  "validation.postalCodeThreeDigits"
                                ),
                              }));
                            }
                          }}
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="homeZip02"
                          width={82}
                          maxLength={4}
                          id="homeZip02"
                          placeholder="0001"
                          value={subValue.homeZip02}
                          onChange={(value) =>
                            handleChangeSubValue("homeZip02", value)
                          }
                          onBlur={(value) => {
                            if (value && value.length < 4) {
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                homeZip02: t("validation.postalCodeFourDigits"),
                              }));
                            }
                          }}
                        />
                        <a
                          href="https://www.post.japanpost.jp/zipcode/index.html"
                          rel="noopener"
                          className="register-form-input_external -vertical"
                          target="_blank"
                        >
                          {t("features.userSetting.contact.postalCodeInfo")}
                        </a>
                      </div>
                      <ErrorMsg
                        error={
                          errors.homeZip01
                            ? errors.homeZip01
                            : errors.homeZip02
                            ? errors.homeZip02
                            : ""
                        }
                        className="invalid-danger"
                      />
                    </div>
                  </div>
                ) : (
                  <div className="data-confirm">
                    {userMetaData?.profile?.address?.postalCode}
                  </div>
                )}
              </dd>
            </div>

            <div
              className={`body-item -address ${
                isEdit ? "item_edit" : "item_confirm"
              }`}
            >
              <dt className="-px5">
                <label>
                  <span>{t("features.userSetting.contact.homeAddress")}</span>
                  {userMetaData?.profile?.contactType === 1 && !forceWorkPlaceValidate && isEdit && (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <>
                    <div className="form-col -col">
                      <div className="form-col_item w-100">
                        <Select
                          name="prefectureCode"
                          id="prefectureCode"
                          value={
                            userMetaData?.profile?.address?.prefectureCode?.toString() ??
                            "0"
                          }
                          error={
                            !forceWorkPlaceValidate && userMetaData?.profile?.contactType === 1 &&
                            !!errors.prefectureCode
                          }
                          label={t("general.prefecture")}
                          onChange={(value) => {
                            const error = validateField(
                              "prefectureCode",
                              value
                            );
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              prefectureCode: error,
                            }));
                            setState((prevState) => ({
                              ...prevState,
                              userMetaData: {
                                ...prevState.userMetaData,
                                profile: {
                                  ...prevState.userMetaData?.profile,
                                  address: {
                                    ...prevState.userMetaData?.profile?.address,
                                    prefectureCode: parseInt(value),
                                  },
                                },
                              },
                            }));
                          }}
                          classNameWrapper="col-5"
                          options={workAddressSelect}
                          defaultValue="0"
                          customSelect={true}
                        />
                        {!forceWorkPlaceValidate && userMetaData?.profile?.contactType === 1 && (
                          <ErrorMsg
                            error={errors.prefectureCode}
                            className="invalid-danger"
                          />
                        )}
                      </div>
                    </div>

                    <div className="form-col -col2  mt-4">
                      <div className="form-col_item w-100">
                        <Input
                          maxLength={80}
                          name="city"
                          label="市区町村"
                          placeholder="例）港区南青山"
                          id="city"
                          error={
                            !forceWorkPlaceValidate && userMetaData?.profile?.contactType === 1
                              ? errors.city
                              : ""
                          }
                          validateMess={
                            !forceWorkPlaceValidate && userMetaData?.profile?.contactType === 1
                              ? errors.city
                              : ""
                          }
                          value={userMetaData?.profile?.address?.city ?? ""}
                          onChange={(value) => {
                            const error = validateField("city", value);
                            setErrors((prevErrors) => ({
                              ...prevErrors,
                              city: error,
                            }));
                            setState((prevState) => ({
                              ...prevState,
                              userMetaData: {
                                ...prevState.userMetaData,
                                profile: {
                                  ...prevState.userMetaData?.profile,
                                  address: {
                                    ...prevState.userMetaData?.profile?.address,
                                    city: value,
                                  },
                                },
                              },
                            }));
                          }}
                          withChecked={true}
                        />
                      </div>
                    </div>

                    <div className="form-col -col2  mt-4">
                      <div className="form-col_item w-100">
                        <div className="form-input">
                          <Input
                            maxLength={200}
                            name="line"
                            value={userMetaData?.profile?.address?.line ?? ""}
                            error={
                              !forceWorkPlaceValidate && userMetaData?.profile?.contactType === 1
                                ? errors.line
                                : ""
                            }
                            validateMess={
                              !forceWorkPlaceValidate && userMetaData?.profile?.contactType === 1
                                ? errors.line
                                : ""
                            }
                            onChange={(value) => {
                              const error = validateField("line", value);
                              setErrors((prevErrors) => ({
                                ...prevErrors,
                                line: error,
                              }));
                              setState((prevState) => ({
                                ...prevState,
                                userMetaData: {
                                  ...prevState.userMetaData,
                                  profile: {
                                    ...prevState.userMetaData?.profile,
                                    address: {
                                      ...prevState.userMetaData?.profile?.address,
                                      line: value,
                                    },
                                  },
                                },
                              }));
                            }}
                            label={t("features.userSetting.contact.addressDetails")}
                            placeholder={t("features.userSetting.contact.addressExample")}
                            id="address02"
                            withChecked={true}
                          />
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="data-confirm">
                    {userMetaData?.profile?.address?.prefectureCode?.toString() !=
                    "48"
                      ? workAddressSelect.find(
                          (item) =>
                            item.value ===
                            userMetaData?.profile?.address?.prefectureCode?.toString()
                        )?.label
                      : ""}
                    {userMetaData?.profile?.address?.city}
                    {userMetaData?.profile?.address?.line}
                  </div>
                )}
              </dd>
            </div>

            <div
              className={`body-item ${isEdit ? "item_edit" : "item_confirm"}`}
            >
              <dt className="-middle">
                <label>
                  <span>{t("features.userSetting.contact.phoneNumber")}</span>
                  {userMetaData?.profile?.contactType === 1 && !forceWorkPlaceValidate && isEdit && (
                    <span className="item_required">
                      {t("general.required")}
                    </span>
                  )}
                </label>
              </dt>
              <dd>
                {isEdit ? (
                  <>
                    <div className="form-col -col2 ">
                      <div className="form-col_item  w-100">
                        <div className="form-input d-flex align-items-center">
                          <Input
                            name="homePhone01"
                            maxLength={4}
                            id="homePhone01"
                            value={subValue.homePhone01 ?? ""}
                            placeholder="03"
                            onChange={(value) =>
                              handleChangeSubValue("homePhone01", value)
                            }
                            onBlur={(value) => {
                              if (value && value.length < 2) {
                                setErrors((prevErrors) => ({
                                  ...prevErrors,
                                  homePhone01: t(
                                    "validation.twoDigitsOrMoreRequired"
                                  ),
                                }));
                              }
                            }}
                          />
                          <span className="form-input_unit -hyphen">-</span>
                          <Input
                            name="homePhone02"
                            id="homePhone02"
                            value={subValue.homePhone02 ?? ""}
                            placeholder="0123"
                            maxLength={4}
                            onChange={(value) =>
                              handleChangeSubValue("homePhone02", value)
                            }
                          />
                          <span className="form-input_unit -hyphen">-</span>
                          <Input
                            name="homePhone03"
                            value={subValue.homePhone03 ?? ""}
                            id="homePhone03"
                            placeholder="4567"
                            maxLength={4}
                            onChange={(value) =>
                              handleChangeSubValue("homePhone03", value)
                            }
                          />
                        </div>
                        <ErrorMsg
                          error={
                            errors.homePhone01
                              ? errors.homePhone01
                              : errors.homePhone02
                              ? errors.homePhone02
                              : errors.homePhone03
                              ? errors.homePhone03
                              : ""
                          }
                          className="invalid-danger"
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="txt-gray data-confirm">
                      {t("general.phone_number")}
                    </div>
                    <div className="data-confirm">
                      {userMetaData?.profile?.phoneNumber}
                    </div>
                    {userMetaData?.profile?.mobilePhoneNumber && (
                      <>
                        <div className="txt-gray data-confirm mt-2">
                          {t("features.userSetting.contact.mobileNumber")}
                        </div>
                        <div className="data-confirm">
                          {userMetaData?.profile?.mobilePhoneNumber}
                        </div>
                      </>
                    )}
                  </>
                )}
              </dd>
            </div>

            {isEdit && (
              <div className="body-item item_edit">
                <dt className="-middle">
                  <label>
                    <span>{t("features.userSetting.contact.mobileNum")}</span>
                  </label>
                </dt>
                <dd>
                  <div className="form-col -col2">
                    <div className="form-col_item w-100">
                      <div className="form-input d-flex align-items-center">
                        <Input
                          name="mobile_homePhone01"
                          maxLength={3}
                          value={subValue.homeMobile01 ?? ""}
                          id="mobile_homePhone01"
                          onChange={(value) =>
                            handleChangeSubValue("homeMobile01", value)
                          }
                          placeholder="090"
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="mobile_homePhone02"
                          value={subValue.homeMobile02 ?? ""}
                          maxLength={4}
                          id="mobile_homePhone02"
                          onChange={(value) =>
                            handleChangeSubValue("homeMobile02", value)
                          }
                          placeholder="0123"
                        />
                        <span className="form-input_unit -hyphen">-</span>
                        <Input
                          name="mobile_homePhone03"
                          value={subValue.homeMobile03 ?? ""}
                          maxLength={4}
                          onChange={(value) =>
                            handleChangeSubValue("homeMobile03", value)
                          }
                          id="mobile_homePhone03"
                          placeholder="4567"
                        />
                      </div>
                      <ErrorMsg
                        error={
                          errors.homeMobile01
                            ? errors.homeMobile01
                            : errors.homeMobile02
                            ? errors.homeMobile02
                            : errors.homeMobile03
                            ? errors.homeMobile03
                            : ""
                        }
                        className="invalid-danger"
                      />
                    </div>
                  </div>
                </dd>
              </div>
            )}
          </dl>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default HomePlace;